<template>

    <div class="mt-10 d-flex align-center pointer gap-6 text-15 weight-600 opacity-60" @click="goBackToChangeEmail">
        <left-arrow></left-arrow> Change email
    </div>

</template>



<script setup>

import { inject } from 'vue';
import LeftArrow from "@/icons/LeftArrow.vue";
import forgotPasswordEvents from '@/Events/ForgotPassword';

const dialogVisible = inject('openDialog');

const goBackToChangeEmail = () => {
    forgotPasswordEvents.emit('open-forgot-password-enter-email-dialog');
    closeForgotPasswordDialog();
};

const closeForgotPasswordDialog = () => {
    dialogVisible.value = false;
}

</script>